(function () {
  'use strict';

  const Money = {
    format(cents) {
      const value = (Number(cents) / 100).toFixed(2);
      const [int, dec] = value.split('.');
      const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return grouped + ',' + dec + ' TL';
    }
  };

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCartCount() {
    try {
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
    } catch (e) {
      /* ignore */
    }
  }

  /* ---------- Countdown timer ---------- */
  function getFlashCountdownEndMs(daysAhead) {
    const d = new Date();
    d.setDate(d.getDate() + daysAhead);
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  }

  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach((el) => {
      let end;
      const endAttr = el.getAttribute('data-countdown-end');
      if (endAttr) {
        end = new Date(endAttr.replace(' ', 'T')).getTime();
      }
      if (!end || isNaN(end)) {
        const todayEnd = getFlashCountdownEndMs(0);
        end = todayEnd > Date.now() ? todayEnd : getFlashCountdownEndMs(1);
      }
      if (end <= Date.now()) {
        end = getFlashCountdownEndMs(1);
      }

      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        if (end <= Date.now()) {
          end = getFlashCountdownEndMs(1);
        }

        let diff = end - Date.now();
        let h = Math.floor(diff / 3.6e6);
        let m = Math.floor((diff % 3.6e6) / 6e4);
        let s = Math.floor((diff % 6e4) / 1000);

        if (h === 0 && m === 0 && s === 0) {
          end = getFlashCountdownEndMs(1);
          diff = end - Date.now();
          h = Math.floor(diff / 3.6e6);
          m = Math.floor((diff % 3.6e6) / 6e4);
          s = Math.floor((diff % 6e4) / 1000);
        }

        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Product gallery helper ---------- */
  const mobileGalleryMq = window.matchMedia('(max-width: 749px)');

  function pauseGalleryVideos(scope) {
    if (!scope) return;
    scope.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
        video.removeAttribute('autoplay');
      } catch (e) {
        /* ignore */
      }
    });
  }

  function hideGalleryUnmute(scope) {
    scope?.querySelectorAll('[data-gallery-unmute]').forEach((btn) => {
      btn.hidden = true;
    });
  }

  const GALLERY_SOUND_ICON_MUTED =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  const GALLERY_SOUND_ICON_ON =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';

  function syncGallerySoundButton(btn, video) {
    if (!btn || !video) return;
    const label = video.muted ? 'Sesi aç' : 'Sesi kapat';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    const span = btn.querySelector('[data-gallery-unmute-label]');
    if (span) span.textContent = label;
    const icon = btn.querySelector('[data-gallery-unmute-icon]');
    if (icon) icon.innerHTML = video.muted ? GALLERY_SOUND_ICON_MUTED : GALLERY_SOUND_ICON_ON;
  }

  function revealGallerySoundButton(item, video) {
    const btn = ensureGalleryUnmuteButton(item);
    if (!btn || !video) return;
    syncGallerySoundButton(btn, video);
    btn.hidden = false;
  }

  function ensureGalleryUnmuteButton(item) {
    if (!item) return null;
    let btn = item.querySelector('[data-gallery-unmute]');
    if (btn) return btn;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ev-gallery__unmute';
    btn.setAttribute('data-gallery-unmute', '');
    btn.hidden = true;
    btn.innerHTML =
      '<span data-gallery-unmute-icon aria-hidden="true">' +
      GALLERY_SOUND_ICON_MUTED +
      '</span><span data-gallery-unmute-label>Sesi aç</span>';
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const wrap = btn.closest('[data-gallery-media], .ev-gallery__slide');
      const video = wrap?.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (!video.paused) {
        video.play().catch(() => {});
      }
      syncGallerySoundButton(btn, video);
    });
    item.appendChild(btn);
    return btn;
  }

  function playGalleryVideo(item) {
    if (!item) return;
    const video = item.querySelector('video');
    if (!video) return;

    video.removeAttribute('autoplay');

    /* Zaten bu instance oynuyorsa yeniden başlatma */
    if (!video.paused && !video.ended) {
      revealGallerySoundButton(item, video);
      return;
    }

    function playMuted() {
      video.muted = true;
      return video.play();
    }

    function onPlaying() {
      revealGallerySoundButton(item, video);
    }

    video.muted = false;
    const playPromise = video.play();
    if (!playPromise || typeof playPromise.catch !== 'function') {
      onPlaying();
      return;
    }

    playPromise.then(onPlaying).catch(() => {
      playMuted().then(onPlaying).catch(() => {});
    });
  }

  function showGalleryMedia(mediaId, galleryRoot) {
    if (!galleryRoot || mediaId == null) return;
    const stage = galleryRoot.querySelector('[data-gallery-stage]');
    if (!stage) return;

    /* Stage + mobil track dahil tüm videoları durdur — çift sesi engeller */
    pauseGalleryVideos(galleryRoot);
    hideGalleryUnmute(galleryRoot);

    const isMobile = mobileGalleryMq.matches;

    stage.querySelectorAll('[data-gallery-media]').forEach((item) => {
      const match = String(item.getAttribute('data-media-id')) === String(mediaId);
      item.hidden = !match;
      item.classList.toggle('is-active', match);
    });

    if (isMobile) {
      const track = galleryRoot.querySelector('[data-gallery-track]');
      const slide = track?.querySelector('.ev-gallery__slide[data-media-id="' + mediaId + '"]');
      if (slide) playGalleryVideo(slide);
      return;
    }

    const activeItem = stage.querySelector(
      '[data-gallery-media][data-media-id="' + mediaId + '"]:not([hidden])'
    );
    if (activeItem) playGalleryVideo(activeItem);
  }

  function setMainImage(src) {
    const galleryRoot = document.querySelector('[data-gallery-root]');
    const stage = galleryRoot?.querySelector('[data-gallery-stage]');
    if (!stage || !src) return;

    let fallback = stage.querySelector('[data-gallery-fallback]');
    if (!fallback) {
      fallback = document.createElement('div');
      fallback.className = 'ev-gallery__media is-active';
      fallback.setAttribute('data-gallery-media', '');
      fallback.setAttribute('data-gallery-fallback', '');
      const img = document.createElement('img');
      img.className = 'ev-gallery__img';
      img.alt = '';
      fallback.appendChild(img);
      stage.appendChild(fallback);
    }

    pauseGalleryVideos(galleryRoot);
    stage.querySelectorAll('[data-gallery-media]').forEach((item) => {
      if (item === fallback) return;
      item.hidden = true;
      item.classList.remove('is-active');
    });
    fallback.hidden = false;
    fallback.classList.add('is-active');
    const img = fallback.querySelector('img');
    if (img) {
      img.removeAttribute('srcset');
      img.src = src;
    }
  }

  function getGalleryThumbs(root) {
    const scope = root || document;
    return Array.from(scope.querySelectorAll('[data-gallery-thumb]')).filter((thumb) => !thumb.hidden);
  }

  function updateGalleryCounter(galleryRoot) {
    if (!galleryRoot) return;
    const counter = galleryRoot.querySelector('[data-gallery-counter]');
    if (!counter) return;

    const thumbs = getGalleryThumbs(galleryRoot);
    if (thumbs.length < 2) {
      counter.hidden = true;
      return;
    }

    counter.hidden = false;
    const currentEl = counter.querySelector('[data-gallery-counter-current]');
    const totalEl = counter.querySelector('[data-gallery-counter-total]');
    const activeIndex = thumbs.findIndex((t) => t.classList.contains('is-active'));
    if (currentEl) currentEl.textContent = String(activeIndex >= 0 ? activeIndex + 1 : 1);
    if (totalEl) totalEl.textContent = String(thumbs.length);
  }

  function destroyMobileGalleryTrack(galleryRoot) {
    if (!galleryRoot) return;
    const track = galleryRoot.querySelector('[data-gallery-track]');
    const stage = galleryRoot.querySelector('[data-gallery-stage]');
    if (track) {
      pauseGalleryVideos(track);
      track.remove();
    }
    if (stage) stage.classList.remove('ev-gallery__stage--hidden-mobile');
  }

  function scrollGalleryTrackToMedia(galleryRoot, mediaId, smooth) {
    const track = galleryRoot?.querySelector('[data-gallery-track]');
    if (!track || mediaId == null) return;
    const slide = track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
  }

  function syncThumbFromGalleryTrack(galleryRoot) {
    const track = galleryRoot?.querySelector('[data-gallery-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('.ev-gallery__slide'));
    if (!slides.length) return;

    const center = track.scrollLeft + track.clientWidth / 2;
    let closest = slides[0];
    let minDist = Infinity;
    slides.forEach((slide) => {
      const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
      const dist = Math.abs(center - slideCenter);
      if (dist < minDist) {
        minDist = dist;
        closest = slide;
      }
    });

    const mediaId = closest.getAttribute('data-media-id');
    const thumbs = getGalleryThumbs(galleryRoot);
    const matched = thumbs.find((t) => String(t.getAttribute('data-media-id')) === String(mediaId));
    if (!matched || matched.classList.contains('is-active')) return;

    thumbs.forEach((t) => t.classList.remove('is-active'));
    matched.classList.add('is-active');
    showGalleryMedia(mediaId, galleryRoot);
    matched.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    updateGalleryCounter(galleryRoot);
  }

  function bindGalleryTrackScroll(galleryRoot, track) {
    if (track.dataset.scrollReady === '1') return;
    track.dataset.scrollReady = '1';

    let scrollTimer;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => syncThumbFromGalleryTrack(galleryRoot), 60);
      },
      { passive: true }
    );
  }

  function syncMobileGalleryTrack(galleryRoot, activeMediaId) {
    if (!galleryRoot) return;

    if (!mobileGalleryMq.matches) {
      destroyMobileGalleryTrack(galleryRoot);
      return;
    }

    const stage = galleryRoot.querySelector('[data-gallery-stage]');
    const galleryMain = galleryRoot.querySelector('.ev-gallery__main');
    if (!stage || !galleryMain) return;

    const thumbs = getGalleryThumbs(galleryRoot);
    if (thumbs.length < 2) {
      destroyMobileGalleryTrack(galleryRoot);
      return;
    }

    let track = galleryRoot.querySelector('[data-gallery-track]');
    const thumbSig = thumbs.map((t) => t.getAttribute('data-media-id')).join(',');

    if (!track) {
      track = document.createElement('div');
      track.className = 'ev-gallery__track';
      track.setAttribute('data-gallery-track', '');
      galleryMain.insertBefore(track, stage);
      stage.classList.add('ev-gallery__stage--hidden-mobile');
      bindGalleryTrackScroll(galleryRoot, track);
    }

    if (track.dataset.thumbSig !== thumbSig) {
      pauseGalleryVideos(track);
      track.innerHTML = '';
      thumbs.forEach((thumb) => {
        const slide = document.createElement('div');
        slide.className = 'ev-gallery__slide';
        const mediaId = thumb.getAttribute('data-media-id') || '';
        slide.setAttribute('data-media-id', mediaId);
        const tpl = galleryRoot.querySelector('template[data-gallery-media-template][data-media-id="' + mediaId + '"]');
        if (tpl?.content?.childNodes?.length) {
          slide.appendChild(tpl.content.cloneNode(true));
        } else {
          const img = document.createElement('img');
          img.src = thumb.getAttribute('data-media-src') || '';
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.className = 'ev-gallery__img';
          slide.appendChild(img);
        }
        track.appendChild(slide);
      });
      track.dataset.thumbSig = thumbSig;
    }

    const activeId =
      activeMediaId != null
        ? activeMediaId
        : thumbs.find((t) => t.classList.contains('is-active'))?.getAttribute('data-media-id');
    if (activeId) scrollGalleryTrackToMedia(galleryRoot, activeId, false);
  }

  function updateVideoThumbPoster(variant, root) {
    const galleryRoot = root?.querySelector('[data-gallery-root]') || document.querySelector('[data-gallery-root]');
    if (!galleryRoot || !variant) return;

    const videoThumb = galleryRoot.querySelector(
      '[data-gallery-thumb][data-media-type="video"], [data-gallery-thumb][data-media-type="external_video"]'
    );
    if (!videoThumb) return;

    const src =
      variant.featured_image?.src ||
      variant.featured_media?.preview_image?.src ||
      variant.featured_media?.src;
    if (!src) return;

    let posterUrl = src;
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', '240');
      posterUrl = url.toString();
    } catch (e) {
      /* keep original src */
    }

    const img = videoThumb.querySelector('.ev-gallery__thumb-poster, img');
    if (img) img.src = posterUrl;
    videoThumb.setAttribute('data-media-src', posterUrl.replace('width=240', 'width=1000'));
  }

  function filterGalleryThumbs(variant, root) {
    const galleryRoot = root?.querySelector('[data-gallery-root]') || document.querySelector('[data-gallery-root]');
    if (!galleryRoot) return null;

    const optionIndex = Number(galleryRoot.getAttribute('data-gallery-option-index') || -1);
    const thumbs = Array.from(galleryRoot.querySelectorAll('[data-gallery-thumb]'));
    if (optionIndex < 0 || !variant) {
      thumbs.forEach((thumb) => {
        thumb.hidden = false;
      });
      galleryRoot.querySelectorAll('[data-gallery-media]').forEach((item) => {
        item.hidden = !item.classList.contains('is-active');
      });
      return getGalleryThumbs(galleryRoot)[0] || null;
    }

    const activeGroup = variant.options?.[optionIndex];
    let firstVisible = null;

    thumbs.forEach((thumb) => {
      const group = thumb.getAttribute('data-gallery-group') || '__shared__';
      const show = group === '__shared__' || group === activeGroup;
      thumb.hidden = !show;
      if (show && !firstVisible) firstVisible = thumb;
    });

    galleryRoot.querySelectorAll('[data-gallery-media]').forEach((item) => {
      const group = item.getAttribute('data-gallery-group') || '__shared__';
      const show = group === '__shared__' || group === activeGroup;
      if (!show) {
        item.hidden = true;
        item.classList.remove('is-active');
      }
    });

    galleryRoot.querySelectorAll('template[data-gallery-media-template]').forEach((tpl) => {
      const group = tpl.getAttribute('data-gallery-group') || '__shared__';
      const show = group === '__shared__' || group === activeGroup;
      if (show) tpl.removeAttribute('data-filter-hidden');
      else tpl.setAttribute('data-filter-hidden', '');
    });

    return firstVisible;
  }

  function activateThumb(mediaId, root) {
    const galleryRoot = root?.querySelector('[data-gallery-root]') || document.querySelector('[data-gallery-root]');
    const thumbs = galleryRoot ? getGalleryThumbs(galleryRoot) : getGalleryThumbs();
    let matched = null;
    thumbs.forEach((thumb) => {
      if (String(thumb.getAttribute('data-media-id')) === String(mediaId)) {
        matched = thumb;
      }
    });
    if (!matched) return false;
    Array.from(galleryRoot?.querySelectorAll('[data-gallery-thumb]') || thumbs).forEach((t) => {
      t.classList.remove('is-active');
    });
    matched.classList.add('is-active');
    showGalleryMedia(mediaId, galleryRoot);
    updateGalleryCounter(galleryRoot);
    syncMobileGalleryTrack(galleryRoot, mediaId);
    return true;
  }

  /* ---------- Product: variant selection ---------- */
  function initMobileOptionPlacement(root, form) {
    const slot = root.querySelector('[data-mobile-options-slot]');
    if (!slot || !form) return;

    const mq = window.matchMedia('(max-width: 749px)');
    const actions = form.querySelector('.ev-product__actions');

    function getOptionGroups() {
      return Array.from(root.querySelectorAll('.ev-option[data-option-index]'));
    }

    function placeOptions() {
      const groups = getOptionGroups();
      if (!groups.length) {
        slot.hidden = true;
        return;
      }

      if (mq.matches) {
        groups.forEach((group) => slot.appendChild(group));
        slot.hidden = false;
      } else {
        groups.forEach((group) => {
          if (actions) form.insertBefore(group, actions);
          else form.appendChild(group);
        });
        slot.hidden = true;
      }
    }

    mq.addEventListener('change', placeOptions);
    placeOptions();
  }

  const VARIANT_VALUES_VISIBLE = 10;

  function initVariantValuesExpand(root) {
    const mq = window.matchMedia('(max-width: 749px)');
    const moreTemplate =
      root.getAttribute('data-variant-expand-more') || '{{ count }} seçenek daha göster';

    root.querySelectorAll('[data-variant-values-wrap]').forEach((wrap) => {
      if (wrap.dataset.expandReady === '1') return;
      wrap.dataset.expandReady = '1';

      const values = wrap.querySelector('[data-variant-values]');
      const btn = wrap.querySelector('[data-variant-expand]');
      if (!values || !btn) return;

      const moreText = btn.querySelector('[data-variant-expand-more]');
      const lessText = btn.querySelector('[data-variant-expand-less]');

      function getItems() {
        return Array.from(values.querySelectorAll('[data-swatch]')).filter(
          (el) => !el.classList.contains('is-soldout')
        );
      }

      function formatMore(count) {
        return moreTemplate.replace(/\{\{\s*count\s*\}\}/g, String(count)).replace('__COUNT__', String(count));
      }

      function applyState(expanded) {
        const items = getItems();
        wrap.classList.toggle('is-expanded', expanded);
        items.forEach((item, index) => {
          item.classList.toggle('ev-swatch--overflow', !expanded && index >= VARIANT_VALUES_VISIBLE);
        });
        if (moreText) moreText.hidden = expanded;
        if (lessText) lessText.hidden = !expanded;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }

      function refresh() {
        const items = getItems();
        const isCards = values.classList.contains('ev-option__values--cards');

        if (mq.matches && isCards) {
          if (items.length <= VARIANT_VALUES_VISIBLE) {
            btn.hidden = true;
            wrap.classList.remove('is-expanded');
            items.forEach((item) => item.classList.remove('ev-swatch--overflow'));
            return;
          }

          btn.hidden = false;
          const hiddenCount = items.length - VARIANT_VALUES_VISIBLE;
          if (moreText) moreText.textContent = formatMore(hiddenCount);
          const expanded = wrap.classList.contains('is-expanded');
          if (expanded) {
            items.forEach((item) => item.classList.remove('ev-swatch--overflow'));
          } else {
            applyState(false);
          }
          if (moreText) moreText.hidden = expanded;
          if (lessText) lessText.hidden = !expanded;
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          return;
        }

        if (mq.matches) {
          btn.hidden = true;
          wrap.classList.remove('is-expanded');
          items.forEach((item) => item.classList.remove('ev-swatch--overflow'));
          return;
        }

        if (items.length <= VARIANT_VALUES_VISIBLE) {
          btn.hidden = true;
          wrap.classList.remove('is-expanded');
          items.forEach((item) => item.classList.remove('ev-swatch--overflow'));
          return;
        }

        btn.hidden = false;
        const hiddenCount = items.length - VARIANT_VALUES_VISIBLE;
        if (moreText) moreText.textContent = formatMore(hiddenCount);

        const checked = values.querySelector('[data-option-input]:checked');
        const checkedLabel = checked?.closest('[data-swatch]');
        const checkedIndex = checkedLabel ? items.indexOf(checkedLabel) : -1;
        applyState(checkedIndex >= VARIANT_VALUES_VISIBLE);
      }

      btn.addEventListener('click', () => {
        const willExpand = !wrap.classList.contains('is-expanded');
        if (mq.matches && values.classList.contains('ev-option__values--cards')) {
          wrap.classList.toggle('is-expanded', willExpand);
          refresh();
          return;
        }
        applyState(willExpand);
      });

      mq.addEventListener('change', refresh);
      refresh();
    });
  }

  function initProductForm() {
    const root = document.querySelector('[data-product-info]');
    if (!root) return;

    const jsonEl = root.querySelector('[data-variants-json]');
    const form = root.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const promoPriceEl = root.querySelector('[data-promo-price]');
    const promoPercent = Number(root.getAttribute('data-promo-percent') || 0);
    const shipInfo = root.querySelector('[data-ship-info]');
    const freeShipThreshold = Number(root.getAttribute('data-free-ship-threshold') || 0);
    const hasFreeShipTag = root.hasAttribute('data-free-ship-tag');
    const addBtn = form.querySelector('[data-add-btn]');
    const addText = form.querySelector('[data-add-text]');
    const qtyInput = form.querySelector('[data-qty-input]');
    let currentVariant = null;
    let productGalleryReady = false;

    let inventory = {};
    const invEl = root.querySelector('[data-inventory-json]');
    if (invEl) {
      try {
        inventory = JSON.parse(invEl.textContent);
      } catch (e) {
        inventory = {};
      }
    }

    function variantMax(variant) {
      if (!variant) return Infinity;
      const info = inventory[variant.id];
      if (info && info.tracked && info.policy !== 'continue') {
        return Math.max(0, Number(info.qty) || 0);
      }
      return Infinity;
    }

    function updateStockInfo(variant) {
      const box = root.querySelector('[data-stock-info]');
      if (!box) return;
      const txtEl = box.querySelector('[data-stock-text]');
      let msg = '';
      let urgent = false;
      if (variant) {
        const info = inventory[variant.id];
        if (info && info.tracked && info.policy !== 'continue') {
          const q = Number(info.qty) || 0;
          if (q > 100) {
            msg = 'Stokta yüzlerce adet mevcut';
          } else if (q >= 10) {
            msg = 'Stokta mevcut';
          } else if (q >= 1) {
            msg = 'Acele et, stokta sadece ' + q + ' adet kaldı!';
            urgent = true;
          }
        } else if (variant.available) {
          msg = 'Stokta mevcut';
        }
      }
      if (msg) {
        if (txtEl) txtEl.textContent = msg;
        box.hidden = false;
        box.classList.toggle('is-urgent', urgent);
      } else {
        box.hidden = true;
      }
    }

    function showStockNote(msg) {
      let note = form.querySelector('[data-stock-note]');
      if (!note) {
        note = document.createElement('div');
        note.setAttribute('data-stock-note', '');
        note.className = 'ev-stock-note';
        const actions = form.querySelector('.ev-product__actions');
        if (actions && actions.parentNode) {
          actions.parentNode.insertBefore(note, actions.nextSibling);
        } else {
          form.appendChild(note);
        }
      }
      note.textContent = msg || '';
      note.style.display = msg ? 'block' : 'none';
    }

    function clampQty() {
      if (!qtyInput) return;
      const max = variantMax(currentVariant);
      let val = Number(qtyInput.value) || 1;
      if (val < 1) val = 1;
      if (isFinite(max)) {
        qtyInput.setAttribute('max', max);
        if (max <= 0) {
          val = 0;
        } else if (val > max) {
          val = max;
          showStockNote('Bu üründen en fazla ' + max + ' adet ekleyebilirsiniz.');
        } else {
          showStockNote('');
        }
      } else {
        qtyInput.removeAttribute('max');
        showStockNote('');
      }
      qtyInput.value = Math.max(1, val);
    }

    function selectedOptions() {
      return Array.from(root.querySelectorAll('[data-option-input]:checked')).map((i) => i.value);
    }

    function matchVariant(opts) {
      return variants.find((v) => v.options.every((o, idx) => o === opts[idx]));
    }

    /* Hide option values that have no available variant given current selection */
    function updateFreeShipping(variant) {
      if (!shipInfo) return;
      const qualifies =
        hasFreeShipTag || (freeShipThreshold > 0 && variant && Number(variant.price) >= freeShipThreshold);
      shipInfo.hidden = !qualifies;
    }

    function updateAvailability() {
      const opts = selectedOptions();
      root.querySelectorAll('[data-swatch]').forEach((swatch) => {
        const position = Number(swatch.getAttribute('data-option-position'));
        const value = swatch.getAttribute('data-option-value');
        const idx = position - 1;
        const exists = variants.some((v) => {
          if (!v.available) return false;
          if (v.options[idx] !== value) return false;
          return v.options.every((o, i) => {
            if (i === idx) return true;
            if (opts[i] == null) return true;
            return o === opts[i];
          });
        });
        if (exists) {
          swatch.classList.remove('is-soldout');
        } else {
          swatch.classList.add('is-soldout');
        }
      });
    }

    function update() {
      const opts = selectedOptions();
      const hasOptions = root.querySelector('[data-option-input]') != null;
      const variant = hasOptions ? matchVariant(opts) : variants[0];

      root.querySelectorAll('[data-option-index]').forEach((group) => {
        const idx = Number(group.getAttribute('data-option-index'));
        const label = group.querySelector('[data-option-selected]');
        if (label && opts[idx]) label.textContent = opts[idx];
      });

      updateAvailability();

      if (!variant) {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addText) addText.textContent = 'Mevcut değil';
        syncSticky();
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = Money.format(variant.price);
      if (promoPriceEl && promoPercent > 0) {
        promoPriceEl.textContent = Money.format(Math.round((variant.price * (100 - promoPercent)) / 100));
      }
      const landingImg = root.querySelector('[data-landing-hero-img]');
      if (landingImg) {
        const imgSrc =
          variant.featured_image?.src ||
          variant.featured_media?.preview_image?.src ||
          variant.featured_media?.src;
        if (imgSrc) landingImg.src = imgSrc;
      }
      updateFreeShipping(variant);

      const firstVisibleThumb = filterGalleryThumbs(variant, root);
      const galleryRootEl = root.querySelector('[data-gallery-root]');
      updateVideoThumbPoster(variant, root);
      updateGalleryCounter(galleryRootEl);

      if (!productGalleryReady) {
        productGalleryReady = true;
        const activeThumb = galleryRootEl?.querySelector('[data-gallery-thumb].is-active:not([hidden])');
        if (activeThumb) {
          activateThumb(activeThumb.getAttribute('data-media-id'), root);
        } else if (firstVisibleThumb) {
          activateThumb(firstVisibleThumb.getAttribute('data-media-id'), root);
        } else {
          syncMobileGalleryTrack(galleryRootEl);
        }
      } else {
        const mediaId = variant.featured_media ? variant.featured_media.id : null;
        if (mediaId && activateThumb(mediaId, root)) {
          /* featured image activated */
        } else if (firstVisibleThumb) {
          activateThumb(firstVisibleThumb.getAttribute('data-media-id'), root);
        } else if (variant.featured_image && variant.featured_image.src) {
          setMainImage(variant.featured_image.src);
          syncMobileGalleryTrack(galleryRootEl);
        } else {
          syncMobileGalleryTrack(galleryRootEl);
        }
      }

      currentVariant = variant;

      if (variant.available) {
        if (addBtn) addBtn.removeAttribute('disabled');
        if (addText) addText.textContent = 'Sepete Ekle';
      } else {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addText) addText.textContent = 'Tükendi';
      }

      updateStockInfo(variant);
      updateInstallments(variant);
      clampQty();
      syncSticky();
    }

    function syncSticky() {
      const sticky = root.querySelector('[data-pdp-sticky]');
      if (!sticky) return;

      const closePanel = () => {
        const panel = sticky.querySelector('[data-pdp-sticky-panel]');
        const backdrop = sticky.querySelector('[data-pdp-sticky-backdrop]');
        const variantBtn = sticky.querySelector('[data-pdp-sticky-variant-btn]');
        if (panel) panel.hidden = true;
        if (backdrop) backdrop.hidden = true;
        if (variantBtn) variantBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('ev-pdp-sticky-panel-open');
      };

      const stickyOptions = sticky.querySelector('[data-pdp-sticky-options]');
      if (stickyOptions) {
        root.querySelectorAll('[data-option-index]').forEach((group) => {
          const checked = group.querySelector('[data-option-input]:checked');
          const soldoutSwatch = checked?.closest('[data-swatch]');
          if (checked && soldoutSwatch?.classList.contains('is-soldout')) {
            const first = group.querySelector('[data-swatch]:not(.is-soldout) [data-option-input]');
            if (first) {
              group.querySelectorAll('[data-option-input]').forEach((input) => {
                input.checked = false;
              });
              first.checked = true;
              first.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }
        });

        root.querySelectorAll('[data-option-index]').forEach((group) => {
          const idx = group.getAttribute('data-option-index');
          let field = stickyOptions.querySelector('[data-sticky-option-index="' + idx + '"]');
          if (!field) {
            const labelEl = group.querySelector('.ev-option__label');
            let optionName = 'Seçenek';
            if (labelEl) {
              optionName = (labelEl.textContent || '').split(':')[0].trim() || optionName;
            }
            field = document.createElement('div');
            field.className = 'ev-pdp-sticky__field';
            field.setAttribute('data-sticky-option-index', idx);
            const label = document.createElement('div');
            label.className = 'ev-pdp-sticky__field-label';
            label.textContent = optionName;
            const grid = document.createElement('div');
            grid.className = 'ev-pdp-sticky__swatches';
            field.appendChild(label);
            field.appendChild(grid);
            stickyOptions.appendChild(field);
          }

          const grid = field.querySelector('.ev-pdp-sticky__swatches');
          grid.innerHTML = '';
          grid.className = 'ev-pdp-sticky__swatches';

          let hasCard = false;
          group.querySelectorAll('[data-swatch]:not(.is-soldout)').forEach((swatch) => {
            const input = swatch.querySelector('[data-option-input]');
            if (!input) return;

            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ev-pdp-sticky__swatch';
            if (input.checked) btn.classList.add('is-selected');

            const thumbImg = swatch.querySelector('.ev-swatch__thumb img');
            const colorEl = swatch.querySelector('.ev-swatch__color');
            const nameEl = swatch.querySelector('.ev-swatch__name');
            const name = nameEl?.textContent?.trim() || input.value;

            if (thumbImg) {
              hasCard = true;
              btn.classList.add('ev-pdp-sticky__swatch--card');
              const media = document.createElement('span');
              media.className = 'ev-pdp-sticky__swatch-media';
              const img = document.createElement('img');
              img.src = thumbImg.currentSrc || thumbImg.src;
              img.alt = name;
              img.loading = 'lazy';
              media.appendChild(img);
              const nameSpan = document.createElement('span');
              nameSpan.className = 'ev-pdp-sticky__swatch-name';
              nameSpan.textContent = name;
              btn.appendChild(media);
              btn.appendChild(nameSpan);
            } else if (colorEl) {
              btn.classList.add('ev-pdp-sticky__swatch--color');
              const dot = document.createElement('span');
              dot.className = 'ev-pdp-sticky__swatch-color';
              const sw =
                colorEl.style.getPropertyValue('--sw') ||
                getComputedStyle(colorEl).getPropertyValue('--sw') ||
                '#ddd';
              dot.style.setProperty('--sw', sw.trim() || '#ddd');
              const nameSpan = document.createElement('span');
              nameSpan.className = 'ev-pdp-sticky__swatch-name';
              nameSpan.textContent = name;
              btn.appendChild(dot);
              btn.appendChild(nameSpan);
            } else {
              btn.classList.add('ev-pdp-sticky__swatch--text');
              btn.textContent = input.value;
            }

            btn.addEventListener('click', () => {
              group.querySelectorAll('[data-option-input]').forEach((optionInput) => {
                optionInput.checked = false;
              });
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              closePanel();
            });
            grid.appendChild(btn);
          });

          if (hasCard) grid.classList.add('ev-pdp-sticky__swatches--cards');
        });
      }

      const stickyPrice = sticky.querySelector('[data-pdp-sticky-price]');
      const stickyPromoPrice = sticky.querySelector('[data-pdp-sticky-promo-price]');
      const stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
      const stickyAddText = sticky.querySelector('[data-pdp-sticky-add-text]');
      const stickyLabel = sticky.querySelector('[data-pdp-sticky-variant-label]');
      const stickyThumb = sticky.querySelector('[data-pdp-sticky-variant-thumb]');

      if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;
      if (stickyPromoPrice && promoPriceEl) stickyPromoPrice.textContent = promoPriceEl.textContent;
      else if (stickyPromoPrice && promoPercent > 0 && currentVariant) {
        stickyPromoPrice.textContent = Money.format(
          Math.round((currentVariant.price * (100 - promoPercent)) / 100)
        );
      }
      if (stickyAdd && addBtn) {
        if (addBtn.hasAttribute('disabled')) stickyAdd.setAttribute('disabled', 'disabled');
        else stickyAdd.removeAttribute('disabled');
      }
      if (stickyAddText && addText) stickyAddText.textContent = addText.textContent;
      if (stickyLabel) {
        const parts = selectedOptions();
        stickyLabel.textContent = parts.length ? parts.join(' · ') : stickyLabel.textContent;
      }
      if (stickyThumb && currentVariant) {
        const src =
          currentVariant.featured_image?.src ||
          currentVariant.featured_media?.preview_image?.src ||
          '';
        if (src) {
          stickyThumb.src = src;
          stickyThumb.alt = currentVariant.title || '';
          stickyThumb.hidden = false;
        } else {
          stickyThumb.hidden = true;
        }
      }
    }

    function updateInterestFree(variant) {
      const box = root.querySelector('[data-inst-free]');
      if (!box) return;

      const instPromo = Number(box.dataset.instFreePromo) || 0;
      const base = Number(variant.price) || 0;
      const net = instPromo > 0 ? Math.round((base * (100 - instPromo)) / 100) : base;

      let count = 0;
      let bestMin = 0;

      (box.dataset.instFreeTiers || '').split(',').forEach((pair) => {
        const [minRaw, countRaw] = pair.split(':');
        const min = parseInt(minRaw, 10);
        const n = parseInt(countRaw, 10);
        if (!min || !n) return;
        if (net >= min * 100 && min >= bestMin) {
          bestMin = min;
          count = n;
        }
      });

      if (count < 2) {
        box.hidden = true;
        return;
      }

      const amount = Money.format(Math.round(net / count));
      const total = Money.format(net);
      const code = box.dataset.instFreeCode || '';
      const fill = (tpl) =>
        (tpl || '')
          .replace(/\{count\}/g, count)
          .replace(/\{amount\}/g, amount)
          .replace(/\{total\}/g, total)
          .replace(/\{code\}/g, code);

      const setLine = (el, tpl) => {
        if (!el) return;
        const value = fill(tpl);
        el.textContent = value;
        el.hidden = value === '';
      };

      setLine(box.querySelector('[data-inst-free-title-el]'), box.dataset.instFreeTitle);
      setLine(box.querySelector('[data-inst-free-amount-el]'), box.dataset.instFreeAmount);
      setLine(box.querySelector('[data-inst-free-text-el]'), box.dataset.instFreeText);
      box.hidden = false;
    }

    let paytrTimer = null;
    function updatePaytrTable(variant) {
      const holder = root.querySelector('[data-paytr-table]');
      if (!holder || !holder.dataset.paytrSrc) return;
      const amount = ((Number(variant.price) || 0) / 100).toFixed(2);
      if (holder.dataset.paytrAmount === amount) return;
      holder.dataset.paytrAmount = amount;

      clearTimeout(paytrTimer);
      paytrTimer = setTimeout(() => {
        const table = holder.querySelector('#paytr_taksit_tablosu');
        if (table) table.innerHTML = '';
        holder.querySelectorAll('[data-paytr-script]').forEach((el) => el.remove());
        const script = document.createElement('script');
        script.src = holder.dataset.paytrSrc + '&amount=' + amount;
        script.async = true;
        script.setAttribute('data-paytr-script', '');
        holder.appendChild(script);
      }, 250);
    }

    function updateInstallments(variant) {
      if (!variant) return;
      updateInterestFree(variant);
      updatePaytrTable(variant);
      const price = Number(variant.price) || 0;
      root.querySelectorAll('[data-inst]').forEach((cell) => {
        const n = parseInt(cell.dataset.n, 10);
        const rate = parseFloat(cell.dataset.rate);
        if (!n || isNaN(rate)) return;
        const total = Math.round((price * (100 + rate)) / 100);
        const value = cell.dataset.kind === 'monthly' ? Math.round(total / n) : total;
        cell.textContent = Money.format(value);
      });
    }

    root.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', update);
    });

    initMobileOptionPlacement(root, form);
    initVariantValuesExpand(root);
    updateGalleryCounter(root.querySelector('[data-gallery-root]'));

    updateAvailability();

    /* Quantity stepper */
    form.querySelector('[data-qty-up]')?.addEventListener('click', () => {
      const max = variantMax(currentVariant);
      const next = Number(qtyInput.value || 1) + 1;
      if (isFinite(max) && next > max) {
        qtyInput.value = max;
        showStockNote('Bu üründen en fazla ' + max + ' adet ekleyebilirsiniz.');
      } else {
        qtyInput.value = next;
        showStockNote('');
      }
    });
    form.querySelector('[data-qty-down]')?.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      showStockNote('');
    });
    qtyInput?.addEventListener('change', clampQty);

    /* AJAX add to cart */
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variantId = idInput ? idInput.value : null;
      let quantity = qtyInput ? Number(qtyInput.value) || 1 : 1;
      if (!variantId) return;

      const max = variantMax(currentVariant);
      if (isFinite(max)) {
        if (max <= 0) {
          showStockNote('Bu ürün stokta yok.');
          return;
        }
        let alreadyInCart = 0;
        try {
          const cart = await fetchCart();
          const line = cart.items.find((it) => String(it.id) === String(variantId));
          if (line) alreadyInCart = line.quantity;
        } catch (e) {
          /* ignore */
        }
        const remaining = max - alreadyInCart;
        if (remaining <= 0) {
          showStockNote('Bu üründen stoktaki tüm adetler (' + max + ') zaten sepetinizde.');
          return;
        }
        if (quantity > remaining) {
          quantity = remaining;
          qtyInput.value = remaining;
          showStockNote('Stok sınırı nedeniyle sepete ' + remaining + ' adet eklendi.');
        }
      }

      if (addBtn) addBtn.setAttribute('disabled', 'disabled');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
        });
        if (!res.ok) {
          let msg = 'Ürün sepete eklenemedi.';
          try {
            const data = await res.json();
            if (data && data.description) msg = data.description;
          } catch (e) {}
          showStockNote(msg);
          if (addBtn) addBtn.removeAttribute('disabled');
          return;
        }
        window.location.href = '/cart';
      } catch (e) {
        if (addBtn) addBtn.removeAttribute('disabled');
        showStockNote('Bir hata oluştu, lütfen tekrar deneyin.');
      }
    });

    const sticky = root.querySelector('[data-pdp-sticky]');
    if (sticky) {
      const stickyMq = window.matchMedia('(max-width: 989px)');
      const stickyPanel = sticky.querySelector('[data-pdp-sticky-panel]');
      const stickyBackdrop = sticky.querySelector('[data-pdp-sticky-backdrop]');
      const stickyOptions = sticky.querySelector('[data-pdp-sticky-options]');
      const stickyVariantBtn = sticky.querySelector('[data-pdp-sticky-variant-btn]');
      const stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
      const actions = form.querySelector('.ev-product__actions');
      let stickyObserver;

      const setStickyPadding = (active) => {
        document.documentElement.classList.toggle('ev-pdp-sticky-active', active && stickyMq.matches);
        if (active && stickyMq.matches) {
          const bar = sticky.querySelector('.ev-pdp-sticky__bar');
          const h = bar ? bar.offsetHeight : 74;
          document.documentElement.style.setProperty('--pdp-sticky-h', h + 'px');
        }
      };

      const closeStickyPanel = () => {
        if (stickyPanel) stickyPanel.hidden = true;
        if (stickyBackdrop) stickyBackdrop.hidden = true;
        if (stickyVariantBtn) stickyVariantBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('ev-pdp-sticky-panel-open');
      };

      const openStickyPanel = () => {
        if (!stickyPanel) return;
        stickyPanel.hidden = false;
        if (stickyBackdrop) stickyBackdrop.hidden = false;
        if (stickyVariantBtn) stickyVariantBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('ev-pdp-sticky-panel-open');
        syncSticky();
      };

      stickyVariantBtn?.addEventListener('click', () => {
        const mobileSlot = root.querySelector('[data-mobile-options-slot]');
        if (stickyMq.matches && mobileSlot && !mobileSlot.hidden) {
          mobileSlot.scrollIntoView({ behavior: 'smooth', block: 'center' });
          closeStickyPanel();
          return;
        }
        if (stickyPanel && stickyPanel.hidden) openStickyPanel();
        else closeStickyPanel();
      });

      sticky.querySelector('[data-pdp-sticky-close]')?.addEventListener('click', closeStickyPanel);
      stickyBackdrop?.addEventListener('click', closeStickyPanel);

      stickyAdd?.addEventListener('click', () => {
        if (stickyAdd.hasAttribute('disabled')) return;
        form.requestSubmit();
      });

      const bindStickyObserver = () => {
        if (stickyObserver) stickyObserver.disconnect();
        if (!stickyMq.matches || !actions) {
          sticky.hidden = true;
          setStickyPadding(false);
          closeStickyPanel();
          return;
        }
        stickyObserver = new IntersectionObserver(
          ([entry]) => {
            const show = !entry.isIntersecting;
            sticky.hidden = !show;
            setStickyPadding(show);
            if (!show) closeStickyPanel();
          },
          { threshold: 0 }
        );
        stickyObserver.observe(actions);
      };

      stickyMq.addEventListener('change', bindStickyObserver);
      bindStickyObserver();
    }

    update();
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    const galleryRoot = document.querySelector('[data-gallery-root]');
    const stage = galleryRoot?.querySelector('[data-gallery-stage]');
    if (!stage || !galleryRoot) return;

    function visibleThumbs() {
      return getGalleryThumbs(galleryRoot);
    }

    function selectThumb(thumb) {
      if (!thumb || thumb.hidden) return;
      Array.from(galleryRoot.querySelectorAll('[data-gallery-thumb]')).forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      showGalleryMedia(thumb.getAttribute('data-media-id'), galleryRoot);
      scrollGalleryTrackToMedia(galleryRoot, thumb.getAttribute('data-media-id'), true);
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      updateGalleryCounter(galleryRoot);
    }

    galleryRoot.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => selectThumb(thumb));
    });

    function step(delta) {
      const thumbs = visibleThumbs();
      if (thumbs.length < 2) return;
      let index = thumbs.findIndex((t) => t.classList.contains('is-active'));
      if (index === -1) index = 0;
      const next = (index + delta + thumbs.length) % thumbs.length;
      selectThumb(thumbs[next]);
    }

    const prevBtn = document.querySelector('[data-gallery-prev]');
    const nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => step(1));

    syncMobileGalleryTrack(galleryRoot);
    mobileGalleryMq.addEventListener('change', () => {
      pauseGalleryVideos(galleryRoot);
      syncMobileGalleryTrack(galleryRoot);
      const activeThumb = galleryRoot.querySelector('[data-gallery-thumb].is-active:not([hidden])');
      const mediaId = activeThumb?.getAttribute('data-media-id');
      if (mediaId) showGalleryMedia(mediaId, galleryRoot);
    });

    /* Tek oynatma yolu — stage + track aynı anda play edilmesin */
    const activeThumb = galleryRoot.querySelector('[data-gallery-thumb].is-active:not([hidden])');
    const activeMedia = stage.querySelector('[data-gallery-media].is-active:not([hidden])');
    const mediaId =
      activeThumb?.getAttribute('data-media-id') || activeMedia?.getAttribute('data-media-id');
    if (mediaId) showGalleryMedia(mediaId, galleryRoot);
  }

  /* ---------- Collection: facet auto-submit + sort ---------- */
  function initFacets() {
    document.querySelectorAll('[data-facets-root]').forEach((root) => {
      const toggle = root.querySelector('[data-facets-toggle]');
      const panel = root.querySelector('[data-facets-panel]');
      const mq = window.matchMedia('(max-width: 989px)');

      const syncPanel = () => {
        if (!toggle || !panel) return;
        if (mq.matches) return;
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      };

      if (toggle && panel) {
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') === 'true';
          const next = !open;
          toggle.setAttribute('aria-expanded', String(next));
          panel.hidden = !next;
        });
        mq.addEventListener('change', syncPanel);
        syncPanel();
      }

      const form = root.querySelector('.ev-facets__form');
      if (form) {
        form.querySelectorAll('[data-auto-submit]').forEach((input) => {
          input.addEventListener('change', () => form.submit());
        });
      }

      root.querySelectorAll('[data-facet-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const facet = btn.closest('[data-facet]');
          const body = facet?.querySelector('[data-facet-body]');
          if (!facet || !body) return;
          const open = !facet.classList.contains('is-open');
          facet.classList.toggle('is-open', open);
          body.hidden = !open;
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      root.querySelectorAll('[data-facet-more]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const facet = btn.closest('.ev-facet');
          if (!facet) return;
          const open = facet.classList.toggle('is-list-expanded');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open
            ? btn.getAttribute('data-label-less') || '− Daralt'
            : btn.getAttribute('data-label-more') || '+ Genişlet';
        });
      });
    });

    const sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* ---------- Cart: line quantity + coupon ---------- */
  function initCart() {
    const root = document.querySelector('[data-cart-root]');
    if (!root) return;

    async function changeLine(line, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
        if (!res.ok) throw new Error('change failed');
        window.location.reload();
      } catch (e) {
        window.location.reload();
      }
    }

    root.querySelectorAll('[data-line-up]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = Number(btn.getAttribute('data-index'));
        const input = root.querySelector('[data-line-qty][data-index="' + idx + '"]');
        changeLine(idx, Number(input.value) + 1);
      });
    });

    root.querySelectorAll('[data-line-down]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = Number(btn.getAttribute('data-index'));
        const input = root.querySelector('[data-line-qty][data-index="' + idx + '"]');
        changeLine(idx, Math.max(0, Number(input.value) - 1));
      });
    });

    root.querySelectorAll('[data-line-qty]').forEach((input) => {
      input.addEventListener('change', () => {
        const idx = Number(input.getAttribute('data-index'));
        changeLine(idx, Math.max(0, Number(input.value)));
      });
    });

    const applyPromoCode = async (code, btn) => {
      if (!code) return;
      if (btn) btn.disabled = true;
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        if (!res.ok) throw new Error('apply failed');
        window.location.reload();
      } catch (e) {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      }
    };

    root.querySelectorAll('[data-cart-promo-apply]').forEach((btn) => {
      btn.addEventListener('click', () => {
        applyPromoCode((btn.getAttribute('data-promo-code') || '').trim(), btn);
      });
    });

    const couponBtn = root.querySelector('[data-coupon-apply]');
    if (couponBtn) {
      const applyCoupon = () => {
        const input = root.querySelector('[data-coupon-input]');
        const code = (input.value || '').trim();
        if (!code) return;
        applyPromoCode(code, couponBtn);
      };
      couponBtn.addEventListener('click', applyCoupon);
      const couponInput = root.querySelector('[data-coupon-input]');
      if (couponInput) {
        couponInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            applyCoupon();
          }
        });
      }
    }

    const couponRemove = root.querySelector('[data-coupon-remove]');
    if (couponRemove) {
      couponRemove.addEventListener('click', async () => {
        couponRemove.disabled = true;
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
          if (!res.ok) throw new Error('remove failed');
          window.location.reload();
        } catch (e) {
          window.location.reload();
        }
      });
    }

    const recsEl = root.querySelector('[data-cart-recommendations]');
    if (recsEl && recsEl.dataset.url) {
      fetch(recsEl.dataset.url)
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('.ev-recs');
          if (content) recsEl.replaceWith(content);
        })
        .catch(() => {});
    }
  }

  /* ---------- Product page: related / vendor / recently viewed ---------- */
  const RV_KEY = 'ev_recently_viewed';

  function injectRow(container, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = doc.querySelector('.ev-prow__inner');
    if (inner) {
      container.innerHTML = inner.outerHTML;
      initProRowSliders(container);
    }
  }

  function initProRowSliders(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-prow-desktop]').forEach((wrap) => {
      if (wrap.dataset.prowSliderReady === '1') return;
      wrap.dataset.prowSliderReady = '1';

      const track = wrap.querySelector('[data-prow-track]');
      const prev = wrap.querySelector('[data-prow-prev]');
      const next = wrap.querySelector('[data-prow-next]');
      if (!track) return;

      const mqDesktop = window.matchMedia('(min-width: 750px)');

      function scrollPage(dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.92, behavior: 'smooth' });
      }

      function updateNav() {
        if (!mqDesktop.matches) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }

        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 4) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }

        if (prev) prev.hidden = track.scrollLeft <= 4;
        if (next) next.hidden = track.scrollLeft >= maxScroll - 4;
      }

      prev?.addEventListener('click', () => scrollPage(-1));
      next?.addEventListener('click', () => scrollPage(1));
      track.addEventListener('scroll', updateNav, { passive: true });
      mqDesktop.addEventListener('change', updateNav);
      window.addEventListener('resize', updateNav);
      updateNav();
    });
  }

  const PROW_DESKTOP_SHELL =
    '<div class="ev-prow__desktop" data-prow-desktop>' +
    '<button type="button" class="ev-prow__nav ev-prow__nav--prev" data-prow-prev hidden aria-label="Önceki">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
    '</button>' +
    '<div class="ev-prow__grid ev-prow__grid--desktop" data-prow-track tabindex="0"></div>' +
    '<button type="button" class="ev-prow__nav ev-prow__nav--next" data-prow-next hidden aria-label="Sonraki">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
    '</button></div>';

  async function copyShareText(value) {
    try {
      await navigator.clipboard.writeText(value);
    } catch (e) {
      const ta = document.createElement('textarea');
      ta.value = value;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
  }

  function initProductShare() {
    const wrap = document.querySelector('[data-product-share]');
    if (!wrap || wrap.dataset.shareBound) return;
    wrap.dataset.shareBound = '1';

    const trigger = wrap.querySelector('[data-product-share-trigger]');
    const menu = wrap.querySelector('[data-product-share-menu]');
    const copyBtn = wrap.querySelector('[data-product-share-copy]');
    const copyLabel = wrap.querySelector('[data-product-share-copy-label]');
    if (!trigger || !menu) return;

    const url = wrap.dataset.shareUrl || window.location.href;
    const title = wrap.dataset.shareTitle || document.title;
    const text = wrap.dataset.shareText || title;
    const copiedLabel = wrap.dataset.shareCopied || 'Link kopyalandı!';
    const defaultCopyLabel = copyLabel ? copyLabel.textContent : '';
    const canNativeShare = typeof navigator.share === 'function';

    function closeMenu() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function toggleMenu() {
      if (menu.hidden) openMenu();
      else closeMenu();
    }

    trigger.addEventListener('click', async () => {
      if (canNativeShare) {
        try {
          await navigator.share({ title, text, url });
        } catch (e) {
          if (e && e.name !== 'AbortError') toggleMenu();
        }
        return;
      }
      toggleMenu();
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        await copyShareText(url);
        copyBtn.classList.add('is-copied');
        if (copyLabel) copyLabel.textContent = copiedLabel;
        window.setTimeout(() => {
          copyBtn.classList.remove('is-copied');
          if (copyLabel) copyLabel.textContent = defaultCopyLabel;
        }, 2000);
        closeMenu();
      });
    }

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeMenu());
    });

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) closeMenu();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeMenu();
    });
  }

  function initLandingSticky() {
    const sticky = document.querySelector('[data-landing-sticky]');
    const buyAnchor = document.getElementById('landing-buy');
    const root = document.querySelector('[data-product-info]');
    if (!sticky || !buyAnchor) return;

    const stickyPrice = sticky.querySelector('[data-landing-sticky-price]');
    const stickyPromoPrice = sticky.querySelector('[data-landing-sticky-promo-price]');
    const heroPrice = root?.querySelector('[data-price]');
    const heroPromoPrice = root?.querySelector('[data-promo-price]');

    function syncPrice() {
      if (stickyPrice && heroPrice) stickyPrice.textContent = heroPrice.textContent;
      if (stickyPromoPrice && heroPromoPrice) stickyPromoPrice.textContent = heroPromoPrice.textContent;
    }

    const observeTargets = [heroPrice, heroPromoPrice].filter(Boolean);
    observeTargets.forEach((el) => {
      const obs = new MutationObserver(syncPrice);
      obs.observe(el, { childList: true, characterData: true, subtree: true });
    });
    syncPrice();

    sticky.querySelector('[data-landing-sticky-buy]')?.addEventListener('click', () => {
      buyAnchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => {
        root?.querySelector('[data-add-btn]')?.focus();
      }, 400);
    });

    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.hidden = entry.isIntersecting;
      },
      { threshold: 0, rootMargin: '0px 0px -20px 0px' }
    );
    observer.observe(buyAnchor);
  }

  function initProductExtras() {
    const root = document.querySelector('[data-product-info]');
    if (!root) return;
    const currentHandle = root.getAttribute('data-product-handle');

    let rvList = [];
    try {
      rvList = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    } catch (e) {
      rvList = [];
    }
    const previous = rvList.filter((h) => h && h !== currentHandle);
    if (currentHandle) {
      const updated = [currentHandle].concat(previous).slice(0, 12);
      try {
        localStorage.setItem(RV_KEY, JSON.stringify(updated));
      } catch (e) {
        /* storage unavailable */
      }
    }

    const relatedEl = document.querySelector('[data-product-related]');
    if (relatedEl && relatedEl.dataset.url) {
      fetch(relatedEl.dataset.url)
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((html) => injectRow(relatedEl, html))
        .catch(() => {});
    }

    const vendorEl = document.querySelector('[data-product-vendor]');
    if (vendorEl && vendorEl.dataset.url) {
      fetch(vendorEl.dataset.url)
        .then((r) => (r.ok ? r.text() : Promise.reject()))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.ev-prow__inner');
          if (!inner) return;

          const cur = vendorEl.dataset.current;
          inner.querySelectorAll('[data-prow-grid-item][data-handle], .ev-prow__item[data-handle]').forEach((el) => {
            if (el.getAttribute('data-handle') === cur) el.remove();
          });

          inner.querySelectorAll('[data-prow-grid-item]').forEach((wrap, index) => {
            if (index >= 12) wrap.remove();
          });
          inner.querySelectorAll('.ev-prow__item').forEach((item, index) => {
            if (index >= 12) item.remove();
          });

          const grid = inner.querySelector('.ev-prow__grid--desktop');
          const list = inner.querySelector('.ev-prow__list--mobile');
          if ((!grid || !grid.children.length) && (!list || !list.children.length)) return;

          vendorEl.innerHTML = inner.outerHTML;
          initProRowSliders(vendorEl);
        })
        .catch(() => {});
    }

    const rvEl = document.querySelector('[data-recently-viewed]');
    if (rvEl && previous.length) {
      const toShow = previous.slice(0, 12);
      Promise.all(
        toShow.map((h) =>
          fetch('/products/' + encodeURIComponent(h) + '?section_id=recently-viewed-card')
            .then((r) => (r.ok ? r.text() : ''))
            .catch(() => '')
        )
      ).then((parts) => {
        const cards = parts.filter((p) => p && p.trim());
        if (!cards.length) return;
        const wrap = document.createElement('div');
        wrap.className = 'ev-prow__inner';
        wrap.innerHTML =
          '<h2 class="ev-prow__title"></h2>' + PROW_DESKTOP_SHELL + '<ol class="ev-prow__list ev-prow__list--mobile"></ol>';
        wrap.querySelector('.ev-prow__title').textContent = rvEl.dataset.title || '';
        const grid = wrap.querySelector('.ev-prow__grid--desktop');
        const list = wrap.querySelector('.ev-prow__list--mobile');
        cards.forEach((c) => {
          const doc = new DOMParser().parseFromString(c, 'text/html');
          const gridItem = doc.querySelector('[data-prow-grid-item]');
          if (gridItem) grid.appendChild(gridItem);
          doc.querySelectorAll('.ev-prow__item').forEach((item) => list.appendChild(item));
        });
        if (grid.children.length || list.children.length) {
          rvEl.innerHTML = '';
          rvEl.appendChild(wrap);
          initProRowSliders(rvEl);
        }
      });
    }
  }

  /* ---------- Brand marquee (infinite scroll) ---------- */
  function initBrandMarquee() {
    document.querySelectorAll('[data-brand-marquee]').forEach((root) => {
      if (root.dataset.brandInit === 'true') return;
      root.dataset.brandInit = 'true';

      const viewport = root.querySelector('[data-brand-viewport]');
      const track = root.querySelector('[data-brand-track]');
      if (!viewport || !track) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) {
        root.classList.add('is-static');
        return;
      }

      let rafId = null;
      let lastTime = 0;
      let offset = 0;
      let loopWidth = 0;
      let paused = false;
      let built = false;
      let visible = false;
      let setupPending = false;
      let lastViewportWidth = 0;
      const durationSec = Math.max(Number(root.dataset.brandDuration) || 44, 12);

      function originals() {
        return Array.from(track.querySelectorAll('[data-brand-original]'));
      }

      function rowWidth(items, gap) {
        if (!items.length) return 0;
        let width = 0;
        items.forEach((item) => {
          width += item.offsetWidth;
        });
        return width + gap * Math.max(items.length - 1, 0);
      }

      function resetClones() {
        track.querySelectorAll('[data-brand-item]:not([data-brand-original])').forEach((node) => node.remove());
        built = false;
        loopWidth = 0;
      }

      function stopAnimation() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        lastTime = 0;
      }

      function buildTrack(preserveProgress) {
        const progress = preserveProgress && loopWidth > 0 ? (Math.abs(offset) % loopWidth) / loopWidth : 0;
        resetClones();

        const base = originals();
        if (!base.length) return;

        const gap = parseFloat(getComputedStyle(track).gap) || 14;
        const baseWidth = rowWidth(base, gap);
        if (!baseWidth) return;

        const minWidth = Math.max(viewport.clientWidth * 1.8, 480);
        const extraSets = Math.max(0, Math.ceil(minWidth / baseWidth) - 1);
        for (let i = 0; i < extraSets; i++) {
          base.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.removeAttribute('id');
            clone.removeAttribute('data-brand-original');
            track.appendChild(clone);
          });
        }

        const firstHalf = Array.from(track.children);
        loopWidth = rowWidth(firstHalf, gap);

        firstHalf.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.removeAttribute('id');
          clone.removeAttribute('data-brand-original');
          track.appendChild(clone);
        });

        built = true;
        offset = preserveProgress && progress ? -progress * loopWidth : 0;
        track.style.transform = loopWidth ? 'translate3d(' + offset + 'px, 0, 0)' : '';
      }

      function tick(time) {
        if (!visible || !built) {
          stopAnimation();
          return;
        }

        if (!lastTime) lastTime = time;
        const delta = Math.min(time - lastTime, 48);
        lastTime = time;

        if (!paused && loopWidth > 0) {
          offset -= (loopWidth / (durationSec * 1000)) * delta;
          if (offset <= -loopWidth) offset += loopWidth;
          track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
        }

        rafId = requestAnimationFrame(tick);
      }

      function startAnimation() {
        if (rafId || !built || !visible) return;
        lastTime = 0;
        rafId = requestAnimationFrame(tick);
      }

      function activate() {
        root.classList.remove('is-static');
        root.classList.add('is-active');
      }

      function isInView() {
        const rect = root.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight + 160;
      }

      function requestSetup(preserveProgress) {
        if (setupPending) return;
        setupPending = true;
        whenImagesReady(() => {
          setupPending = false;
          setup(!!preserveProgress);
          if (!built && isInView()) {
            window.setTimeout(() => {
              if (!built) whenImagesReady(() => setup(false));
            }, 120);
          }
        });
      }

      function onVisibilityChange(isVisible) {
        visible = isVisible;
        if (visible) {
          if (!built) requestSetup(false);
          else startAnimation();
        } else {
          stopAnimation();
        }
      }

      function setup(preserveProgress) {
        buildTrack(!!preserveProgress);
        if (!built) return;
        lastViewportWidth = Math.round(viewport.clientWidth);
        activate();
        if (visible) startAnimation();
      }

      function whenImagesReady(cb) {
        const imgs = track.querySelectorAll('img');
        let pending = imgs.length;
        if (!pending) {
          cb();
          return;
        }
        imgs.forEach((img) => {
          if (img.complete) {
            pending -= 1;
            if (pending === 0) cb();
          } else {
            img.addEventListener('load', () => { pending -= 1; if (pending === 0) cb(); }, { once: true });
            img.addEventListener('error', () => { pending -= 1; if (pending === 0) cb(); }, { once: true });
          }
        });
      }

      if (window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseenter', () => { paused = true; });
        root.addEventListener('mouseleave', () => { paused = false; });
      }

      const visibilityObserver = new IntersectionObserver((entries) => {
        onVisibilityChange(entries[0].isIntersecting);
      }, { rootMargin: '160px 0px', threshold: 0.01 });

      visibilityObserver.observe(root);

      if (isInView()) onVisibilityChange(true);

      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver((entries) => {
          if (!visible) return;
          const width = Math.round(entries[0]?.contentRect?.width || viewport.clientWidth);
          if (!width || width === lastViewportWidth) return;
          lastViewportWidth = width;
          stopAnimation();
          requestSetup(true);
        });
        ro.observe(viewport);
      }
    });
  }

  function initBrandTooltips() {
    let tip = document.querySelector('[data-brand-tooltip]');
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'ev-brands__tooltip';
      tip.setAttribute('data-brand-tooltip', '');
      tip.setAttribute('role', 'tooltip');
      tip.hidden = true;
      document.body.appendChild(tip);
    }

    function hideTooltip() {
      tip.hidden = true;
      tip.classList.remove('is-visible', 'is-below');
    }

    function showTooltip(tile) {
      const text = tile.getAttribute('data-tooltip');
      if (!text) {
        hideTooltip();
        return;
      }

      tip.textContent = text;
      tip.hidden = false;
      tip.classList.remove('is-visible', 'is-below');

      requestAnimationFrame(() => {
        const rect = tile.getBoundingClientRect();
        const tipWidth = tip.offsetWidth;
        const tipHeight = tip.offsetHeight;
        let left = rect.left + rect.width / 2 - tipWidth / 2;
        let top = rect.top - tipHeight - 12;
        let below = false;

        left = Math.max(12, Math.min(left, window.innerWidth - tipWidth - 12));
        if (top < 8) {
          top = rect.bottom + 12;
          below = true;
        }

        tip.style.left = left + 'px';
        tip.style.top = top + 'px';
        tip.classList.toggle('is-below', below);
        tip.classList.add('is-visible');
      });
    }

    document.querySelectorAll('[data-brand-marquee]').forEach((root) => {
      if (root.dataset.brandTooltipInit === 'true') return;
      root.dataset.brandTooltipInit = 'true';

      root.addEventListener('mouseover', (event) => {
        const tile = event.target.closest('[data-tooltip]');
        if (tile && root.contains(tile)) showTooltip(tile);
      });

      root.addEventListener('mouseleave', hideTooltip);
    });
  }

  /* ---------- Hero slider ---------- */
  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-slider-track]');
      const slides = Array.from(slider.querySelectorAll('[data-slider-slide]'));
      if (!track || slides.length < 2) return;

      const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
      let index = 0;
      let timer = null;
      const autoplay = slider.getAttribute('data-autoplay') === 'true';
      const interval = Number(slider.getAttribute('data-interval')) || 5000;

      function goTo(i, smooth) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
        dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
      }

      function next() { goTo(index + 1); }
      function prev() { goTo(index - 1); }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(next, interval);
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      slider.querySelector('[data-slider-next]')?.addEventListener('click', () => { next(); start(); });
      slider.querySelector('[data-slider-prev]')?.addEventListener('click', () => { prev(); start(); });
      dots.forEach((dot) => {
        dot.addEventListener('click', () => { goTo(Number(dot.getAttribute('data-index'))); start(); });
      });

      let scrollDebounce = null;
      track.addEventListener('scroll', () => {
        if (scrollDebounce) clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index) {
            index = i;
            dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
          }
        }, 80);
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);

      start();
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer() {
    const drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    const openBtn = document.querySelector('[data-drawer-open]');

    function open() {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => drawer.classList.add('is-open'));
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { drawer.hidden = true; }, 280);
    }

    openBtn?.addEventListener('click', open);
    drawer.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    drawer.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sub = btn.nextElementSibling;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (sub) sub.hidden = expanded;
      });
    });
  }

  /* ---------- Wishlist (favorites) ---------- */
  const Wishlist = {
    key: 'evle:wishlist',
    get() {
      try {
        return JSON.parse(localStorage.getItem(this.key)) || [];
      } catch (e) {
        return [];
      }
    },
    save(list) {
      localStorage.setItem(this.key, JSON.stringify(list));
    },
    has(handle) {
      return this.get().indexOf(handle) !== -1;
    },
    toggle(handle) {
      const list = this.get();
      const idx = list.indexOf(handle);
      if (idx === -1) {
        list.push(handle);
      } else {
        list.splice(idx, 1);
      }
      this.save(list);
      return idx === -1;
    }
  };

  function updateWishlistButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = Wishlist.has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  function updateWishlistCount() {
    const count = Wishlist.get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = count;
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', 'hidden');
      }
    });
  }

  function initWishlist() {
    updateWishlistButtons();
    updateWishlistCount();

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      event.preventDefault();
      const handle = btn.getAttribute('data-handle');
      if (!handle) return;
      Wishlist.toggle(handle);
      updateWishlistButtons();
      updateWishlistCount();
      const page = document.querySelector('[data-wishlist-page]');
      if (page) renderWishlistPage();
    });
  }

  async function renderWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    const loading = document.querySelector('[data-wishlist-loading]');
    if (!grid) return;

    const handles = Wishlist.get();
    if (loading) loading.setAttribute('hidden', 'hidden');

    if (handles.length === 0) {
      grid.setAttribute('hidden', 'hidden');
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }

    if (empty) empty.setAttribute('hidden', 'hidden');
    grid.removeAttribute('hidden');

    const results = await Promise.all(
      handles.map((handle) =>
        fetch('/products/' + handle + '.js')
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    );

    grid.innerHTML = '';
    results.forEach((product, i) => {
      if (!product) return;
      const handle = handles[i];
      const onSale = product.compare_at_price && product.compare_at_price > product.price;
      const img = product.featured_image || (product.images && product.images[0]) || '';
      const imgUrl = img ? (img.indexOf('//') === 0 ? img : img) : '';
      const card = document.createElement('div');
      card.className = 'ev-card';
      card.innerHTML =
        '<a href="' + product.url + '" class="ev-card__media">' +
        (imgUrl ? '<img src="' + imgUrl + '&width=600" alt="" loading="lazy">' : '') +
        (onSale ? '<span class="ev-card__badge">İNDİRİM</span>' : '') +
        '</a>' +
        '<button type="button" class="ev-card__fav is-active" data-wishlist-toggle data-handle="' + handle + '" aria-label="Favorilerden çıkar" aria-pressed="true">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="#e0245e" stroke="#e0245e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.5C9.5 18.6 3.5 14.3 3.5 9.2 3.5 6.6 5.5 4.8 8 4.8c1.8 0 3.2.9 4 2.3.8-1.4 2.2-2.3 4-2.3 2.5 0 4.5 1.8 4.5 4.4 0 5.1-6 9.4-8.5 11.3z"/></svg>' +
        '</button>' +
        '<a href="' + product.url + '" class="ev-card__body">' +
        (product.vendor ? '<div class="ev-card__brand">' + product.vendor + '</div>' : '') +
        '<div class="ev-card__title">' + product.title + '</div>' +
        '<div class="ev-price"><span class="ev-price__now">' + Money.format(product.price) + '</span>' +
        (onSale ? '<span class="ev-price__old">' + Money.format(product.compare_at_price) + '</span>' : '') +
        '</div>' +
        '</a>';
      grid.appendChild(card);
    });

    updateWishlistButtons();
  }

  function initAuth() {
    const loginView = document.querySelector('[data-login-form]');
    const recoverView = document.querySelector('[data-recover-form]');
    if (!loginView || !recoverView) return;
    document.querySelectorAll('[data-recover-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        loginView.classList.add('is-hidden');
        recoverView.classList.add('is-active');
      });
    });
    document.querySelectorAll('[data-recover-back]').forEach((btn) => {
      btn.addEventListener('click', () => {
        recoverView.classList.remove('is-active');
        loginView.classList.remove('is-hidden');
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach((root) => {
      const tabs = root.querySelectorAll('[data-tab]');
      const panels = root.querySelectorAll('[data-panel]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-tab');
          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          let activated = null;
          panels.forEach((p) => {
            const match = p.getAttribute('data-panel') === target;
            p.classList.toggle('is-active', match);
            p.hidden = !match;
            if (match) activated = p;
          });
          if (activated && activated.querySelector('[data-judgeme-panel], #judgeme_product_reviews')) {
            window.dispatchEvent(new Event('resize'));
          }
        });
      });
    });
  }

  function initShipCountdown() {
    document.querySelectorAll('[data-ship-countdown][data-remaining]').forEach((el) => {
      let remaining = parseInt(el.getAttribute('data-remaining'), 10);
      if (isNaN(remaining)) return;
      const textEl = el.querySelector('[data-ship-text]');
      const tpl = el.getAttribute('data-today-tpl') || '{{ timer }} içinde';
      const expiredMsg = el.getAttribute('data-expired-msg') || '';

      function fmt(total) {
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        let out = '';
        if (h > 0) out += h + ' saat ';
        out += m + ' dakika ' + s + ' saniye';
        return out;
      }

      function render() {
        if (remaining <= 0) {
          if (textEl) textEl.textContent = expiredMsg;
          el.classList.remove('is-today');
          clearInterval(timer);
          return;
        }
        if (textEl) {
          const html = tpl.replace('__T__', '<strong class="ev-ship-cd__timer">' + fmt(remaining) + '</strong>');
          textEl.innerHTML = html;
        }
        remaining -= 1;
      }

      render();
      const timer = setInterval(render, 1000);
    });
  }

  /* ---------- Header: desktop sticky shadow ---------- */
  function initHeaderSticky() {
    const header = document.querySelector('.ev-header[data-sticky="true"]');
    const group = document.querySelector('.shopify-section-group-header-group');
    if (!header || !group) return;

    const mq = window.matchMedia('(min-width: 990px)');
    let ticking = false;

    function update() {
      ticking = false;
      if (!mq.matches) {
        group.classList.remove('is-stuck');
        return;
      }
      group.classList.toggle('is-stuck', window.scrollY > 4);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    mq.addEventListener('change', update);
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------- Campaign bar countdown ---------- */
  function initCampaignBar() {
    document.querySelectorAll('[data-campaign-bar]').forEach((bar) => {
      const endAttr = bar.getAttribute('data-campaign-end');
      const timers = bar.querySelectorAll('[data-campaign-timer]');
      if (!endAttr || !timers.length) return;

      const end = new Date(endAttr.replace(' ', 'T')).getTime();
      if (isNaN(end)) {
        timers.forEach((el) => el.remove());
        return;
      }

      const hideExpired = bar.getAttribute('data-campaign-hide-expired') === 'true';
      const pad = (n) => String(n).padStart(2, '0');
      let interval = null;

      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          if (interval) clearInterval(interval);
          if (hideExpired) {
            bar.hidden = true;
          } else {
            timers.forEach((el) => {
              el.textContent = '00:00:00';
            });
          }
          return;
        }

        const days = Math.floor(diff / 8.64e7);
        const hours = Math.floor((diff % 8.64e7) / 3.6e6);
        const mins = Math.floor((diff % 3.6e6) / 6e4);
        const secs = Math.floor((diff % 6e4) / 1000);
        const clock = pad(hours) + ':' + pad(mins) + ':' + pad(secs);
        const text = days > 0 ? days + ' gün ' + clock : clock;

        timers.forEach((el) => {
          el.textContent = text;
        });
      };

      tick();
      interval = setInterval(tick, 1000);
    });
  }

  /* ---------- Sticky newsletter panel ---------- */
  function initNewsletterSticky() {
    const root = document.querySelector('[data-newsletter-sticky]');
    if (!root) return;

    const STORAGE_KEY = 'evle-newsletter-subscribed';
    const panel = root.querySelector('.ev-newsletter-sticky__panel');
    const overlay = root.querySelector('.ev-newsletter-sticky__overlay');
    const openBtn = root.querySelector('[data-newsletter-open]');
    const closeBtns = root.querySelectorAll('[data-newsletter-close]');

    function hideWidget() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      root.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function markSubscribed() {
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {
        /* ignore */
      }
      hideWidget();
    }

    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        hideWidget();
        return;
      }
    } catch (e) {
      /* ignore */
    }

    if (root.hasAttribute('data-newsletter-success')) {
      markSubscribed();
      return;
    }

    function openPanel() {
      root.classList.add('is-open');
      if (panel) {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
      }
      if (overlay) overlay.hidden = false;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const input = root.querySelector('#NewsletterStickyEmail');
      if (input) window.setTimeout(() => input.focus(), 280);
    }

    function closePanel() {
      root.classList.remove('is-open');
      if (panel) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
      }
      if (overlay) overlay.hidden = true;
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    openBtn?.addEventListener('click', openPanel);
    closeBtns.forEach((btn) => btn.addEventListener('click', closePanel));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closePanel();
    });

    if (root.hasAttribute('data-newsletter-error') || root.classList.contains('has-error')) {
      openPanel();
    }
  }

  /* ---------- Cookie consent bar ---------- */
  function initCookieBar() {
    const bar = document.querySelector('[data-cookie-bar]');
    if (!bar) return;

    const STORAGE_KEY = 'evle-cookie-consent';
    const acceptBtn = bar.querySelector('[data-cookie-accept]');

    function hideBar() {
      bar.classList.remove('is-visible');
      bar.hidden = true;
      document.body.classList.remove('has-cookie-bar');
      window.setTimeout(() => {
        bar.style.display = 'none';
      }, 360);
    }

    function acceptCookies() {
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {
        /* ignore */
      }
      hideBar();
    }

    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') {
        bar.style.display = 'none';
        return;
      }
    } catch (e) {
      /* ignore */
    }

    bar.hidden = false;
    bar.style.display = '';
    document.body.classList.add('has-cookie-bar');
    window.requestAnimationFrame(() => {
      bar.classList.add('is-visible');
    });

    acceptBtn?.addEventListener('click', acceptCookies);
  }

  /* ---------- App install strip (mobile web only) ---------- */
  function initAppPromo() {
    const bar = document.querySelector('[data-app-promo]');
    if (!bar) return;

    /* Uygulamanin kendi WebView'inde gosterilmez. */
    if (document.documentElement.classList.contains('evle-app')) {
      bar.remove();
      return;
    }

    const STORAGE_KEY = 'evle-app-promo-dismissed';
    const ua = navigator.userAgent;
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);

    /* iOS Safari'de Apple'in kendi uygulama bandi cikiyor; ikisi ust uste
       gelmesin. Chrome/Firefox gibi diger iOS tarayicilarinda banner yok,
       serit oralarda devreye girer. */
    const isIOSSafari = isIOS && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
    if (isIOSSafari) return;

    const url = isAndroid ? bar.dataset.appPromoAndroid : isIOS ? bar.dataset.appPromoIos : '';
    if (!url) return;

    const snoozeDays = Number(bar.dataset.appPromoDays) || 30;

    function snooze() {
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {
        /* ignore */
      }
    }

    function hideBar() {
      bar.classList.remove('is-visible');
      window.setTimeout(() => {
        bar.hidden = true;
      }, 260);
    }

    try {
      const last = Number(localStorage.getItem(STORAGE_KEY));
      if (last && Date.now() - last < snoozeDays * 864e5) return;
    } catch (e) {
      /* ignore */
    }

    const link = bar.querySelector('[data-app-promo-link]');
    if (link) {
      link.href = url;
      /* Magazaya giden kullaniciya tekrar hatirlatma. */
      link.addEventListener('click', snooze);
    }

    bar.querySelector('[data-app-promo-close]')?.addEventListener('click', () => {
      snooze();
      hideBar();
    });

    bar.hidden = false;
    window.requestAnimationFrame(() => {
      bar.classList.add('is-visible');
    });
  }

  /* ---------- Scroll to top button ---------- */
  function initScrollTop() {
    const btn = document.querySelector('[data-scroll-top]');
    if (!btn) return;

    let ticking = false;
    const threshold = Number(btn.dataset.scrollTopThreshold) || 400;

    function update() {
      ticking = false;
      const show = window.scrollY > threshold;
      btn.hidden = !show;
      btn.classList.toggle('is-visible', show);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ---------- Contact page: IBAN copy ---------- */
  function initContactCopy() {
    document.querySelectorAll('[data-copy-value]').forEach((btn) => {
      if (btn.dataset.copyBound) return;
      btn.dataset.copyBound = '1';
      const actionEl = btn.querySelector('.ev-contact__copy-action, [data-copy-action]');
      const defaultLabel = btn.getAttribute('data-copy-default') || 'Kopyala';
      const doneLabel = btn.getAttribute('data-copy-done') || 'Kopyalandı';

      btn.addEventListener('click', async () => {
        const value = btn.getAttribute('data-copy-value');
        if (!value) return;
        try {
          await navigator.clipboard.writeText(value);
        } catch (e) {
          const ta = document.createElement('textarea');
          ta.value = value;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        btn.classList.add('is-copied');
        if (actionEl) actionEl.textContent = doneLabel;
        window.setTimeout(() => {
          btn.classList.remove('is-copied');
          if (actionEl) actionEl.textContent = defaultLabel;
        }, 2000);
      });
    });
  }

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch() {
    const escapeHtml = (value) =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    document.querySelectorAll('[data-predictive-search]').forEach((form) => {
      const input = form.querySelector('[data-predictive-input]');
      const panel = form.querySelector('[data-predictive-panel]');
      if (!input || !panel) return;

      if (input.type === 'search') input.type = 'text';
      input.setAttribute('inputmode', 'search');
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-haspopup', 'listbox');
      if (!input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', input.placeholder || 'Ara');
      }
      if (!input.hasAttribute('aria-autocomplete')) {
        input.setAttribute('aria-autocomplete', 'list');
      }
      if (!input.hasAttribute('aria-expanded')) {
        input.setAttribute('aria-expanded', 'false');
      }
      if (panel.id && !input.getAttribute('aria-controls')) {
        input.setAttribute('aria-controls', panel.id);
      }

      const urlBase = form.dataset.predictiveUrl || '/search/suggest.json';
      const searchUrl = form.dataset.searchUrl || '/search';
      const labels = {
        products: form.dataset.i18nProducts || 'Ürünler',
        collections: form.dataset.i18nCollections || 'Koleksiyonlar',
        viewAll: form.dataset.i18nViewAll || 'Tüm sonuçları gör',
        empty: form.dataset.i18nEmpty || 'Sonuç bulunamadı',
        loading: form.dataset.i18nLoading || 'Aranıyor...',
        fallback: form.dataset.i18nFallback || '"{term}" için öneriler gösteriliyor',
        emptyHint: form.dataset.i18nEmptyHint || "Canlı aramada sonuç yok. Enter'a basın veya tüm sonuçlara gidin."
      };

      let debounceTimer = null;
      let abortController = null;
      let activeIndex = -1;
      let items = [];

      function closePanel() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIndex = -1;
        items = [];
      }

      function openPanel() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function assignOptionIds() {
        const prefix = panel.id || 'PredictiveSearch';
        getItems().forEach((el, i) => {
          el.id = prefix + '-opt-' + i;
        });
      }

      function setStatus(message) {
        panel.innerHTML = '<p class="ev-search__status" role="status">' + escapeHtml(message) + '</p>';
        openPanel();
      }

      function getItems() {
        return Array.from(panel.querySelectorAll('.ev-search__item, .ev-search__view-all'));
      }

      function setActiveItem(index) {
        items = getItems();
        items.forEach((el) => el.classList.remove('is-active'));
        if (index < 0 || index >= items.length) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
          return;
        }
        activeIndex = index;
        const active = items[index];
        if (!active.id) active.id = (panel.id || 'PredictiveSearch') + '-opt-' + index;
        active.classList.add('is-active');
        input.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
      }

      function buildProductItem(product) {
        const image = product.image
          ? '<img class="ev-search__thumb" src="' + escapeHtml(product.image) + '" alt="" width="44" height="44" loading="lazy">'
          : '<span class="ev-search__thumb ev-search__thumb--collection" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16l-1.2 11.5a1 1 0 0 1-1 .8H6.2a1 1 0 0 1-1-.8L4 7z"/><path d="M9 7V5.5a3 3 0 0 1 6 0V7"/></svg></span>';
        const price = product.price ? escapeHtml(product.price) + ' TL' : '';
        const vendor = product.vendor ? '<span class="ev-search__item-meta">' + escapeHtml(product.vendor) + '</span>' : '';

        return (
          '<a href="' +
          escapeHtml(product.url) +
          '" class="ev-search__item" role="option">' +
          image +
          '<span class="ev-search__item-body"><span class="ev-search__item-title">' +
          escapeHtml(product.title) +
          '</span>' +
          vendor +
          '</span>' +
          (price ? '<span class="ev-search__item-price">' + price + '</span>' : '') +
          '</a>'
        );
      }

      function buildCollectionItem(collection) {
        const collectionImage = collection.image || collection.featured_image?.url || '';
        const image = collectionImage
          ? '<img class="ev-search__thumb" src="' + escapeHtml(collectionImage) + '" alt="" width="44" height="44" loading="lazy">'
          : '<span class="ev-search__thumb ev-search__thumb--collection" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h5l2 3h9v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z"/></svg></span>';

        return (
          '<a href="' +
          escapeHtml(collection.url) +
          '" class="ev-search__item" role="option">' +
          image +
          '<span class="ev-search__item-body"><span class="ev-search__item-title">' +
          escapeHtml(collection.title) +
          '</span></span>' +
          '</a>'
        );
      }

      async function fetchResource(query, type, limit, signal) {
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', type);
        params.set('resources[limit]', String(limit));
        if (type === 'product') {
          params.set('resources[options][unavailable_products]', 'hide');
        }

        const res = await fetch(urlBase + '?' + params.toString(), {
          signal,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('Predictive search failed');
        const data = await res.json();
        const results = data?.resources?.results || {};
        return results[type + 's'] || [];
      }

      function buildViewAllLink(query) {
        return (
          '<a href="' +
          escapeHtml(searchUrl) +
          '?q=' +
          encodeURIComponent(query) +
          '&type=product" class="ev-search__view-all" role="option">' +
          escapeHtml(labels.viewAll) +
          ' &rarr;</a>'
        );
      }

      async function fetchSearchPageResults(query, signal) {
        const params = new URLSearchParams();
        params.set('q', query);
        params.set('type', 'product');
        params.set('view', 'predictive');

        const res = await fetch(searchUrl + '?' + params.toString(), {
          signal,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('Search failed');
        return res.json();
      }

      async function fetchResults(query) {
        if (abortController) abortController.abort();
        abortController = new AbortController();
        const signal = abortController.signal;

        const [searchData, collections] = await Promise.all([
          fetchSearchPageResults(query, signal),
          fetchResource(query, 'collection', 3, signal)
        ]);

        return {
          products: searchData.products || [],
          collections: collections.slice(0, 3),
          matchedQuery: query,
          originalQuery: query
        };
      }

      function renderResults(data, query) {
        const products = data.products || [];
        const collections = data.collections || [];
        const matchedQuery = data.matchedQuery || query;
        const originalQuery = data.originalQuery || query;
        const usedFallback = matchedQuery !== originalQuery;

        if (!products.length && !collections.length) {
          panel.innerHTML =
            '<p class="ev-search__status" role="status">' +
            escapeHtml(labels.empty) +
            '</p>' +
            '<p class="ev-search__status">' +
            escapeHtml(labels.emptyHint) +
            '</p>' +
            buildViewAllLink(originalQuery);
          openPanel();
          activeIndex = -1;
          assignOptionIds();
          items = getItems();
          return;
        }

        let html = '';

        if (usedFallback) {
          html +=
            '<p class="ev-search__status ev-search__status--hint" role="status">' +
            escapeHtml(labels.fallback.replace('{term}', matchedQuery)) +
            '</p>';
        }

        if (products.length) {
          html += '<div class="ev-search__group"><div class="ev-search__group-title">' + escapeHtml(labels.products) + '</div>';
          products.forEach((product) => {
            html += buildProductItem(product);
          });
          html += '</div>';
        }

        if (collections.length) {
          html += '<div class="ev-search__group"><div class="ev-search__group-title">' + escapeHtml(labels.collections) + '</div>';
          collections.forEach((collection) => {
            html += buildCollectionItem(collection);
          });
          html += '</div>';
        }

        html += buildViewAllLink(originalQuery);

        panel.innerHTML = html;
        openPanel();
        activeIndex = -1;
        assignOptionIds();
        items = getItems();
      }

      function scheduleSearch() {
        clearTimeout(debounceTimer);
        const query = input.value.trim();

        if (query.length < 2) {
          closePanel();
          panel.innerHTML = '';
          return;
        }

        debounceTimer = window.setTimeout(async () => {
          setStatus(labels.loading);
          try {
            const data = await fetchResults(query);
            renderResults(data, query);
          } catch (error) {
            if (error.name === 'AbortError') return;
            closePanel();
          }
        }, 320);
      }

      input.addEventListener('input', scheduleSearch);

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.innerHTML) openPanel();
      });

      input.addEventListener('keydown', (event) => {
        if (panel.hidden) return;
        items = getItems();
        if (!items.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          const next = activeIndex < items.length - 1 ? activeIndex + 1 : 0;
          setActiveItem(next);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          const next = activeIndex > 0 ? activeIndex - 1 : items.length - 1;
          setActiveItem(next);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          items[activeIndex].click();
        } else if (event.key === 'Escape') {
          closePanel();
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closePanel();
      });

      form.addEventListener('submit', () => {
        closePanel();
      });
    });
  }

  /* ---------- Footer accordion (mobile) ---------- */
  function initFooterAccordion() {
    const items = document.querySelectorAll('.ev-footer__accordion');
    if (!items.length) return;

    const mq = window.matchMedia('(min-width: 750px)');

    function sync() {
      items.forEach((item) => {
        if (mq.matches) item.setAttribute('open', '');
        else item.removeAttribute('open');
      });
    }

    items.forEach((item) => {
      item.querySelector('summary')?.addEventListener('click', (event) => {
        if (mq.matches) event.preventDefault();
      });
    });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
    } else {
      mq.addListener(sync);
    }

    sync();
  }

  /* ---------- SEO content: read more / less ---------- */
  function initSeoContent() {
    document.querySelectorAll('[data-seo-content]').forEach((root) => {
      const body = root.querySelector('[data-seo-body]');
      const toggle = root.querySelector('[data-seo-toggle]');
      const more = root.querySelector('[data-seo-more]');
      const less = root.querySelector('[data-seo-less]');
      const fade = root.querySelector('[data-seo-fade]');
      if (!body || !toggle) return;

      const collapsed = Number(root.getAttribute('data-collapsed-height')) || 140;
      body.style.setProperty('--seo-collapsed', collapsed + 'px');

      if (body.scrollHeight <= collapsed + 8) {
        toggle.hidden = true;
        if (fade) fade.remove();
        body.classList.add('is-expanded');
        return;
      }

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const next = !expanded;
        toggle.setAttribute('aria-expanded', String(next));
        body.classList.toggle('is-expanded', next);
        if (more) more.hidden = next;
        if (less) less.hidden = !next;
      });
    });
  }

  function pageHas(selector) {
    return !!document.querySelector(selector);
  }

  /* ---------- Product card videos (collection / grid) ---------- */
  function initProductCardVideos() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const cards = Array.from(document.querySelectorAll('[data-card-media]'));
    if (!cards.length) return;

    const mqDesktop = window.matchMedia('(min-width: 750px)');
    const MAX_PLAYING = 2;
    const playing = new Set();

    function getVideo(wrap) {
      return wrap.querySelector('video.ev-card__video');
    }

    function pauseCardVideo(wrap) {
      if (!wrap) return;
      const video = getVideo(wrap);
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {
        /* ignore */
      }
      wrap.classList.remove('is-playing');
      playing.delete(video);
    }

    function playCardVideo(wrap) {
      const video = getVideo(wrap);
      if (!video) return;

      while (playing.size >= MAX_PLAYING) {
        const oldest = playing.values().next().value;
        pauseCardVideo(oldest.closest('[data-card-media]'));
      }

      video.muted = true;
      const playPromise = video.play();
      if (!playPromise || typeof playPromise.then !== 'function') {
        wrap.classList.add('is-playing');
        playing.add(video);
        return;
      }

      playPromise
        .then(() => {
          wrap.classList.add('is-playing');
          playing.add(video);
        })
        .catch(() => {});
    }

    cards.forEach((wrap) => {
      wrap.addEventListener('mouseenter', () => {
        if (mqDesktop.matches) playCardVideo(wrap);
      });
      wrap.addEventListener('mouseleave', () => {
        if (mqDesktop.matches) pauseCardVideo(wrap);
      });
    });

    const mobileObserver = new IntersectionObserver(
      (entries) => {
        if (mqDesktop.matches) return;
        entries.forEach((entry) => {
          const wrap = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            playCardVideo(wrap);
          } else {
            pauseCardVideo(wrap);
          }
        });
      },
      { threshold: [0, 0.6, 1], rootMargin: '0px 0px -8% 0px' }
    );

    function bindMobileObserver() {
      cards.forEach((wrap) => {
        if (mqDesktop.matches) {
          mobileObserver.unobserve(wrap);
          pauseCardVideo(wrap);
        } else {
          mobileObserver.observe(wrap);
        }
      });
    }

    bindMobileObserver();
    mqDesktop.addEventListener('change', bindMobileObserver);
  }

  function bootTheme() {
    refreshCartCount();

    initDrawer();
    initHeaderSticky();
    initScrollTop();
    initCookieBar();
    initAppPromo();
    initFooterAccordion();

    if (pageHas('[data-wishlist-toggle]') || pageHas('[data-wishlist-page]')) initWishlist();
    if (pageHas('[data-predictive-search]')) initPredictiveSearch();
    if (pageHas('[data-newsletter-sticky]')) initNewsletterSticky();
    if (pageHas('[data-campaign-bar]')) initCampaignBar();

    if (pageHas('[data-countdown]')) initCountdown();
    if (pageHas('[data-slider]')) initSliders();
    if (pageHas('[data-tabs]')) initTabs();
    if (pageHas('[data-brand-marquee]')) {
      initBrandMarquee();
      initBrandTooltips();
    }
    if (pageHas('[data-seo-content]')) initSeoContent();

    if (pageHas('[data-product-info]')) {
      initProductForm();
      initGallery();
      initShipCountdown();
      initProductShare();
      initProductExtras();
    }

    if (pageHas('[data-landing-sticky]')) initLandingSticky();

    if (pageHas('[data-facets-root]')) initFacets();
    if (pageHas('[data-card-media]')) initProductCardVideos();
    if (pageHas('[data-cart-root]')) initCart();
    if (pageHas('[data-login-form]')) initAuth();
    if (pageHas('[data-copy-value]')) initContactCopy();

    if (pageHas('[data-wishlist-page]')) renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', bootTheme);

  window.EvleTheme = { Money, fetchCart, refreshCartCount, updateCartCount };
})();
